import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { useState, useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'
import * as controllers from 'controllers'
import ReadyForOutboundDateAddEditDialog from './ReadyForOutboundDateAddEditDialog'
import { ExplanationAccordion, LabelField } from 'components'
import { SettingsReadyForOutboundDateInformationDto } from 'dtos'

export default function ReadyForOutboundDateListCard() {
  const [readyForOutboundDateInformation, setReadyForOutboundDateInformation] =
    useState<SettingsReadyForOutboundDateInformationDto>(new SettingsReadyForOutboundDateInformationDto())
  const [isReadyForOutboundDateSaving, setIsReadyForOutboundDateSaving] = useState<boolean>(false)
  const [readyForOutboundDateAddEditDialogOpen, setReadyForOutboundDateAddEditDialogOpen] = useState<boolean>(false)
  const [isGettingReadyForOutboundDateInformation, setIsGettingReadyForOutboundDateInformation] = useState<boolean>(false)

  useEffect(() => {
    setIsGettingReadyForOutboundDateInformation(true)
    controllers
      .getReadyForOutboundDateInformation()
      .then(response => {
        setReadyForOutboundDateInformation(response.value)
      })
      .finally(() => {
        setIsGettingReadyForOutboundDateInformation(false)
      })
  }, [])

  return (
    <>
      <ReadyForOutboundDateAddEditDialog
        initialValues={readyForOutboundDateInformation}
        isLoading={isReadyForOutboundDateSaving}
        onClose={() => {
          setReadyForOutboundDateAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsReadyForOutboundDateSaving(true)
          controllers
            .updateReadyForOutboundDateInformation(values)
            .then(response => {
              enqueueSnackbar('Ready For Outbound Date Information Saved Successfully', { variant: 'success' })
              setReadyForOutboundDateInformation(response.value)
              setReadyForOutboundDateAddEditDialogOpen(false)
            })
            .finally(() => {
              setIsReadyForOutboundDateSaving(false)
            })
        }}
        open={readyForOutboundDateAddEditDialogOpen}
      />
      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Ready For Outbound Date
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button
                  onClick={() => {
                    setReadyForOutboundDateAddEditDialogOpen(true)
                  }}
                  variant='text'
                  endIcon={<Edit />}
                >
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingReadyForOutboundDateInformation && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingReadyForOutboundDateInformation && (
              <Grid item xs={12}>
                <LabelField
                  label='Number of Days Before Vehicle Release'
                  value={readyForOutboundDateInformation.readyForOutboundNumberOfDaysBeforeVehicleRelease}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||The Ready for Outbound Date is the date when vehicles may be added to Outbound Trips. This control exists so
                that vehicles may be added to Outbound Trips before the Vehicle Release Date is reached (the 30-day hold
                expires). Note that a vehicle immediately becomes “Ready for Outbound” when the Bond Release document for the
                vehicle is OCR'd and attached to the VIN, regardless of the Vehicle Release Date or Ready for Outbound Date
                controls. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
